// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vWyZX","label":"styles_label__3kN0K"};